/* Direction-aware shared header: no API or cart requests. */
(() => {
 const init = header => {
  if (header.dataset.rfHeaderReady) return;
  header.dataset.rfHeaderReady = 'true';
  const menu=header.querySelector('[data-rf-mobile-nav]'),language=header.querySelector('[data-rf-language]');
  let lastY=Math.max(0,scrollY),offset=0,queued=false,returnFrame=0,upwardTravel=0;
  const revealThreshold=80;
  const paint=()=>{
   const height=header.getBoundingClientRect().height;
   offset=Math.min(offset,height);
   header.style.transform=`translateY(${-offset}px)`;
   header.classList.toggle('rf-header--hidden',offset>=height);
   header.closest('.rf-home')?.style.setProperty('--rf-header-visible-height',`${Math.max(0,height-offset)}px`);
  };
  const previewOwnsScreen=()=>{
  if(innerWidth>=990||Math.max(0,scrollY)<=0||!header.closest('.rf-sun-page'))return false;
  const gallery=header.closest('.rf-sun-page').querySelector('[data-sun-gallery]');
  if(!gallery||gallery.hidden)return false;
  // Derive the portrait sticky boundary from the purchase panel, not the
  // gallery's previous-frame sticky offset when scrolling back from the story.
  const purchase=gallery.closest('reflective-sun-guide')?.querySelector('.rf-sun-purchase');
  if(purchase&&!matchMedia('(max-height:500px) and (orientation:landscape)').matches)return purchase.getBoundingClientRect().top>12;
  const rect=gallery.getBoundingClientRect();
  return rect.bottom>0&&rect.top<innerHeight;
 };
 const hideForPreview=()=>{
  cancelAnimationFrame(returnFrame);returnFrame=0;upwardTravel=0;
  offset=header.getBoundingClientRect().height;paint();
 };
 const show=()=>{
   if(previewOwnsScreen()){hideForPreview();return;}
   if(returnFrame)return;
   if(!offset||matchMedia('(prefers-reduced-motion: reduce)').matches){offset=0;paint();return;}
   const from=offset,start=performance.now();
   const reveal=now=>{
    if(previewOwnsScreen()){hideForPreview();return;}
    const progress=Math.min(1,(now-start)/240);
    offset=from*Math.pow(1-progress,3);paint();
    returnFrame=progress<1?requestAnimationFrame(reveal):0;
   };
   returnFrame=requestAnimationFrame(reveal);
  };
  const pinned=()=>menu?.open||language?.open||(header.contains(document.activeElement)&&document.activeElement.matches(':focus-visible'));
  const update=()=>{
   queued=false;const y=Math.max(0,scrollY),delta=y-lastY;
   header.classList.toggle('rf-header--scrolled',y>80);
   if(previewOwnsScreen()){hideForPreview();}
   else if(y===0||pinned()){upwardTravel=0;show();}
   else if(delta<0){
    upwardTravel-=delta;
    if(upwardTravel>=revealThreshold)show();
   } else if(delta>0){upwardTravel=0;cancelAnimationFrame(returnFrame);returnFrame=0;offset+=delta;paint();}
   lastY=y;
  };
  addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(update);}},{passive:true});
  header.addEventListener('focusin',show);
  for(const panel of [menu,language])panel?.addEventListener('toggle',()=>{if(panel.open){show();for(const other of [menu,language])if(other&&other!==panel)other.open=false;}});
  header.addEventListener('keydown',e=>{if(e.key!=='Escape')return;const panel=[menu,language].find(p=>p?.open);if(panel){panel.open=false;panel.querySelector('summary').focus();e.preventDefault();}});
  document.addEventListener('click',e=>{if(!header.contains(e.target))for(const panel of [menu,language])if(panel)panel.open=false;});
  menu?.addEventListener('click',e=>{if(e.target.closest('a'))menu.open=false;});
  const size=()=>header.classList.toggle('rf-header--large-text',parseFloat(getComputedStyle(document.documentElement).fontSize)>=18);
  new ResizeObserver(size).observe(document.documentElement);new ResizeObserver(paint).observe(header);addEventListener('resize',()=>{size();update();},{passive:true});size();paint();update();
 };
 const start=()=>document.querySelectorAll('[data-rf-header]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
